export const trimObjectProperties = (object) => {
  return Object.keys(object).reduce((acc, key) => {
    acc[key] = typeof object[key] === 'string' ? object[key].trim() : object[key];
    return acc;
  }, {});
};
